import React from 'react';
import DistributionChartForSalaryScore from 'src/components/university/dashboard/DistributionChartForSalaryScore';
import AverageScoreComparison from 'src/components/university/dashboard/AverageScoreComparison';
import DistributionChartForEligibleForPlacement from 'src/components/university/dashboard/DistributionChartForEligibleForPlacement';
import StatsCard from 'src/components/university/dashboard/StatsCard';
import TopperScoreComparison from 'src/components/university/dashboard/TopperScoreComparison';
import { useGetUniversityStudentStats } from 'src/hooks/user.hooks';
import { GetUniversityStudentStatsAPIResponse } from 'types';
import { Loader } from 'ui';
import NewCreatingPositionLoader from 'src/components/position/NewCreatingPositionLoader';

const UniversityDashboard = () => {
	const { data, isLoading: isStudentsLoading } = useGetUniversityStudentStats();
	if (isStudentsLoading) {
		return (
			<div className="flex items-center justify-center relative top-[25vh]">
				{/* <Loader /> */}
				<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="!w-[25%] mx-auto " />
			</div>
		);
	}
	const props = {
		aiInterViewTakenUsers: data?.aiInterViewTakenUsers,
		automatedInterViewTakenUsers: data?.automatedInterViewTakenUsers,
		totalUsers: data?.totalUsers,
		mockTestTakers: data?.mockTestTakers,
		eligileStudentsForPlacement: data?.eligileStudentsForPlacement,
		ineligibleStudentsForPlacement: data?.ineligibleStudentsForPlacement,
		salaryDistribution: data?.salaryDistribution,
		scoreDistribution: data?.scoreDistribution,
		avgScore: data?.avgScore,
		avgScoreOtherColleges: data?.avgScoreOtherColleges,
		topperFromCollege: data?.topperFromCollege,
		topperFromOtherColleges: data?.topperFromOtherColleges,
		mandatoryFormFilledUsers: data?.mandatoryFormFilledUsers,
		aiAndAutomatedInterviewUsers: data?.aiAndAutomatedInterviewUsers,
		bothFormFilledUsers: data?.bothFormFilledUsers,
		optionalFormFilledUsers: data?.optionalFormFilledUsers,
		aiInterViewAttemptedUsers: data?.aiInterViewAttemptedUsers,
		automatedInterViewAttemptedUsers: data?.automatedInterViewAttemptedUsers,
		aiAndAutomatedInterviewAttemptedUsers: data?.aiAndAutomatedInterviewAttemptedUsers,
	} as GetUniversityStudentStatsAPIResponse;

	return (
		<div className="flex flex-col gap-4 max-w-[1440px] px-4 pb-8 xl:px-[80px] mx-auto">
			<div className="w-full">
				<StatsCard data={props} />
			</div>
			<div className="w-full flex flex-col gap-8 lg:flex-row mx-auto justify-center">
				<DistributionChartForSalaryScore
					scoreChatValues={props.scoreDistribution}
					salaryChatValues={props.salaryDistribution}
				/>
				<DistributionChartForEligibleForPlacement
					chartValues={[props.eligileStudentsForPlacement || 0, props.ineligibleStudentsForPlacement || 0]}
				/>
			</div>

			{/* <div className="w-full flex flex-col items-start  mx-auto">
				<div className="flex w-full mb-[14px]">
					<h3 className="text-xl font-semibold text-[#555770] font-inter">Comparison with other colleges</h3>
				</div>
				<div className="w-full flex flex-col gap-8 md:flex-row ">
					<AverageScoreComparison chartValues={[props?.avgScore || 0, props?.avgScoreOtherColleges || 0]} />
				</div>
			</div> */}
		</div>
	);
};

export default UniversityDashboard;
